<template>
  <header id="header" class="scroll-hide" background-color= "#ffaa8c">
 
    <div class="header-wrapper">
      <div class="container">
        <div id="logo">
          <a href="/">
            <p>Hash Pandas</p>
          </a>
        </div>
        <nav>
          <div class="menu-button menu-open">
            <i class="open-icon ion-android-menu"></i
            ><i class="close-icon ion-android-close"></i>
          </div>
          <ul class="flexnav standard" data-breakpoint="800">
            <li>
              <router-link exact-active-class="active" to="/">{{$t('menu.home')}}</router-link>
            </li>
            <li>
              <router-link to="/overview" exact-active-class="active"
                >{{$t('menu.overview')}}</router-link
              >
            </li>
             <li>
              <router-link to="/gallerybinance" exact-active-class="active"
                >{{$t('menu.gallerybinance')}}</router-link
              >
            </li>
            <li>
              <router-link to="/gallery" exact-active-class="active"
                >{{$t('menu.gallery')}}</router-link
              >
            </li>
           
            <li>
              <router-link to="/nct" exact-active-class="active"
                >NCT Token</router-link
              >
            </li>
            <li>
              <router-link to="/wallet" exact-active-class="active"
                >{{$t('menu.myWallet')}}</router-link
              >
            </li>
           
            <li>
              <router-link
                to="/wallet-history"
                exact-active-class="active"
                :class="'not-pending-' + !pendingTx.length"
              >
                <span v-if="!pendingTx || !pendingTx.length">
                 {{$t('menu.walletHistory')}}
                </span>
                <div class="header-pending-tx" v-else>
                  <button class="mint-button" disabled="disabled">
                    <div class="loading-circle"></div>
                    <span class="pending-text"
                      >{{ pendingTx.length }} Pending Tx</span
                    >
                  </button>

                </div>
              </router-link>
            </li>
             <li> 
              <button  class="mint-button"   v-on:click="changeLanguage()">{{$t('language.name')}}</button>
               <!-- <div @click="changeLanguage()">{{$t('language.name')}}</div>   -->
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { getTransactionReceipt } from '../helpers/contract.js';
import Web3 from 'web3';

export default {
  name: 'Header',
  data() {
    return {
      timer: '',
      windowWeb3: null,
    };
  },
  mounted() {
    // Begin: Header Nav bar JS
    const open = document.querySelector('.open-icon');
    const close = document.querySelector('.close-icon');
    const nav = document.querySelector('.flexnav');
    open.addEventListener('click', function() {
      nav.style.maxHeight = 'none';
      open.style.display = 'none';
      close.style.display = 'block';
    });
    close.addEventListener('click', function() {
      nav.style.maxHeight = '0';
      open.style.display = 'block';
      close.style.display = 'none';
    });
    // End: Header Nav bar JS

    this.$store.commit('setInfuraWeb3');
    if (window.ethereum) {
      this.windowWeb3 = new Web3(window.ethereum);
      this.checkWalletAndPendingTransactions();
      this.timer = setInterval(this.checkWalletAndPendingTransactions, 1000);
    }
  },
  computed: {
    pendingTx() {
      return this.$store.state.pendingTx;
    },
  },
  methods: {
      changeLanguage(){
       
      this.$i18n.locale=='zh'?this.$i18n.locale='en':this.$i18n.locale='zh'  //设置中英文模式
      localStorage.setItem('languageSet',this.$i18n.locale)  //将用户设置存储到localStorage以便用户下次打开时使用此设置
    },
    async checkWalletAndPendingTransactions() {
      const accounts = await this.windowWeb3.eth.getAccounts();
      this.$store.commit('setDefaultAccount', accounts[0]);

      const isLocked = !accounts || 0 === accounts.length;
      if (!this.$store.state.isWalletConnected && !isLocked) {
        this.$store.commit('setWalletWeb3');
      }

      for (const txDetails of this.$store.state.pendingTx) {
        const receipt = await getTransactionReceipt(
          this.windowWeb3,
          txDetails.txHash,
        );
        if (receipt) {
          this.$store.commit('completeTx', {
            txDetails,
            status: receipt.status,
          });
        }
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>

<style></style>
